module.exports = __webpack_public_path__ + "static/media/salisbury-2.e7911cd8.jpg";